import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  FaHome, 
  FaUserNurse, 
  FaCalendarAlt, 
  FaUsers, 
  FaCreditCard, 
  FaMoneyCheckAlt,
  FaConciergeBell,
  FaFileAlt,
  FaSignOutAlt,
  FaAward,
  FaWallet,
  FaTicketAlt,
  FaComments,
  FaClipboardList,
  FaFlag
} from 'react-icons/fa';
import './Sidebar.css';

const Sidebar = ({ isOpen, toggleSidebar, logout }) => {
  const location = useLocation();

  const handleLinkClick = () => {
    // Auto-close sidebar on mobile after clicking a link
    if (window.innerWidth < 769 && isOpen) {
      toggleSidebar();
    }
  };

  const menuItems = [
    { path: '/dashboard', icon: <FaHome />, label: 'Dashboard' },
    { path: '/bookings', icon: <FaCalendarAlt />, label: 'Bookings' },
    { path: '/providers', icon: <FaUserNurse />, label: 'Providers' },
    { path: '/customers', icon: <FaUsers />, label: 'Customers' },
    { path: '/services', icon: <FaConciergeBell />, label: 'Services' },
    { path: '/payments', icon: <FaCreditCard />, label: 'Payments' },
    { path: '/payouts', icon: <FaMoneyCheckAlt />, label: 'Payouts' },
   //{ path: '/refunds', icon: <FaUndoAlt />, label: 'Refunds' },
    // { path: '/disputes', icon: <FaExclamationTriangle />, label: 'Disputes' },
    { path: '/support/tickets', icon: <FaTicketAlt />, label: 'Disputes' },
   // { path: '/promotions', icon: <FaTag />, label: 'Promotions' },
    { path: '/content', icon: <FaFileAlt />, label: 'Content' },
    //{ path: '/analytics', icon: <FaChartLine />, label: 'Analytics' },
    { path: '/loyalty', icon: <FaAward />, label: 'Loyalty' },
    { path: '/wallet', icon: <FaWallet />, label: 'Wallet' },
    { path: '/chat-history', icon: <FaComments />, label: 'Chat History' },
    //{ path: '/settings', icon: <FaCog />, label: 'Settings' },
    { path: '/audit-log', icon: <FaClipboardList />, label: 'Audit Log' },
    //{ path: '/spam-reports', icon: <FaFlag />, label: 'Spam Reports' }
  ];

  return (
    <>
      {isOpen && <div className="sidebar-backdrop" onClick={toggleSidebar}></div>}
      <div className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <div className="logo">
            <img src="/logo192.png" alt="Tiny Care Logo" className="logo-image" />
            {isOpen && <span className="logo-text" style={{ marginLeft: '12px' }}>TinyCare</span>}
          </div>
        </div>

        <nav className="sidebar-nav">
          {menuItems.map((item, index) => (
            <Link
              key={index}
              to={item.path}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
              onClick={handleLinkClick}
            >
              <span className="nav-icon">{item.icon}</span>
              {isOpen && <span className="nav-label">{item.label}</span>}
              {isOpen && item.badge && (
                <span className="nav-badge">{item.badge}</span>
              )}
            </Link>
          ))}
          <div 
            className="nav-item logout-nav-item" 
            onClick={() => {
              handleLinkClick();
              logout();
            }}
            style={{ cursor: 'pointer' }}
          >
            <span className="nav-icon"><FaSignOutAlt /></span>
            {isOpen && <span className="nav-label">Logout</span>}
          </div>
        </nav>

        <div className="sidebar-footer">
          {isOpen && (
            <div className="footer-content">
              <p className="footer-text">TinyCare Admin</p>
              <p className="footer-version">v1.0.0</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Sidebar;